export default "__VITE_ASSET__BARcJJ7Y__"